import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './Reducers';

const initialState = {};
const middleware = [thunk];
const store = createStore(reducers, initialState, applyMiddleware(...middleware));

export default store;